/* eslint-disable import/no-default-export */
import React from 'react';

import { CreateTeam } from 'app/gamma/src/components/create-team';
import Overlay, { OverlayBackground } from 'app/gamma/src/components/overlay';

import styles from './create-team.less';

const CreateTeamOverlay = () => (
  <Overlay
    background={OverlayBackground.LIGHT}
    className={styles.createTeamOverlay}
  >
    <CreateTeam />
  </Overlay>
);

export default CreateTeamOverlay;
